"use client";

import React from "react";
import {
  Row,
  Col,
  Button,
  Divider,
  Spin,
  Card,
  Form,
  Input,
  Select,
  DatePicker,
  InputNumber,
  Collapse,
  Icon,
} from "antd";
import moment from "moment";
import api from "../../../services/api";
import OptionsService from "../../../services/OptionsService";
import "./component.css";

class Report extends React.Component {
  state = {
    loading: false,
    filters: {
      // Parcela
      status_parcela: null,
      status_conciliado: null,
      forma_pagamento: null,
      data_vencimento_ini: null,
      data_vencimento_fim: null,
      data_pagamento_ini: null,
      data_pagamento_fim: null,
      valor_parcela_min: null,
      valor_parcela_max: null,
      // Acordo
      acordo_status_acordo: null,
      acordo_tipo_acordo: null,
      acordo_tipo_cobranca: null,
      acordo_operador_username: null,
      acordo_data_acordo_ini: null,
      acordo_data_acordo_fim: null,
      acordo_numero_cliente: null,
      acordo_numero_processo: null,
      acordo_dias_em_atraso_min: null,
      acordo_dias_em_atraso_max: null,
      acordo_valor_acordo_min: null,
      acordo_valor_acordo_max: null,
      // Pasta/Cliente
      acordo_pasta_pasta: null,
      acordo_pasta_cpf_cnpj: null,
      acordo_pasta_cooperado: null,
      acordo_pasta_cooperado_search: null,
      acordo_pasta_agencia: null,
      acordo_pasta_singular: null,
    },
    // Opções dinâmicas
    agenciaOptions: [],
    cooperadoOptions: [],
    singularOptions: [],
    tipoCobrancaOptions: [],
    tipoAcordoOptions: [],
    formaPagamentoOptions: [],
    statusConciliadoOptions: [],
    statusParcelaOptions: [],
    operadorOptions: [],
    loadingOptions: {
      agencia: false,
      cooperado: false,
      singular: false,
      tipoCobranca: false,
      tipoAcordo: false,
      formaPagamento: false,
      statusConciliado: false,
      statusParcela: false,
      operador: false,
    },
    activeReport: null,
  };

  componentDidMount() {
    // Carrega conjuntos pequenos na montagem
    this.fetchTipoCobrancaOptions("");
    this.fetchTipoAcordoOptions("");
    this.fetchFormaPagamentoOptions("");
    this.fetchStatusConciliadoOptions("");
    this.fetchStatusParcelaOptions("");
  }

  onFilterChange = (fieldName, value) => {
    this.setState(function (prevState) {
      return {
        filters: {
          ...prevState.filters,
          [fieldName]: value,
        },
      };
    });
  };

  onDateRangeChange = (startField, endField, dates) => {
    if (!dates || dates.length === 0) {
      this.setState(function (prevState) {
        return {
          filters: {
            ...prevState.filters,
            [startField]: null,
            [endField]: null,
          },
        };
      });
      return;
    }

    const start = dates[0] ? dates[0].format("YYYY-MM-DD") : null;
    const end = dates[1] ? dates[1].format("YYYY-MM-DD") : null;

    this.setState(function (prevState) {
      return {
        filters: {
          ...prevState.filters,
          [startField]: start,
          [endField]: end,
        },
      };
    });
  };

  fetchOptions = async (optionType, serviceMethod, query) => {
    const q = typeof query === "string" ? query : "";
    this.setState(function (prevState) {
      return {
        loadingOptions: {
          ...prevState.loadingOptions,
          [optionType]: true,
        },
      };
    });

    try {
      const response = await serviceMethod(q);
      const data = response && response.data ? response.data : [];
      this.setState(function () {
        return {
          [optionType + "Options"]: data,
        };
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error fetching " + optionType + " options:", error);
    } finally {
      this.setState(function (prevState) {
        return {
          loadingOptions: {
            ...prevState.loadingOptions,
            [optionType]: false,
          },
        };
      });
    }
  };

  fetchTipoCobrancaOptions = (query) => {
    return this.fetchOptions(
      "tipoCobranca",
      OptionsService.getTipoCobrancaOptions,
      query
    );
  };

  fetchTipoAcordoOptions = (query) => {
    return this.fetchOptions(
      "tipoAcordo",
      OptionsService.getTipoAcordoOptions,
      query
    );
  };

  fetchAgenciaOptions = (query) => {
    return this.fetchOptions(
      "agencia",
      OptionsService.getAgenciaOptions,
      query
    );
  };

  fetchCooperadoOptions = (query) => {
    return this.fetchOptions(
      "cooperado",
      OptionsService.getCooperadoOptions,
      query
    );
  };

  fetchSingularOptions = (query) => {
    return this.fetchOptions(
      "singular",
      OptionsService.getSingularOptions,
      query
    );
  };

  fetchFormaPagamentoOptions = (query) => {
    return this.fetchOptions(
      "formaPagamento",
      OptionsService.getFormaPagamentoOptions,
      query
    );
  };

  fetchStatusConciliadoOptions = (query) => {
    return this.fetchOptions(
      "statusConciliado",
      OptionsService.getStatusConciliadoOptions,
      query
    );
  };

  fetchStatusParcelaOptions = (query) => {
    return this.fetchOptions(
      "statusParcela",
      OptionsService.getStatusParcelaOptions,
      query
    );
  };

  fetchOperadorOptions = (query) => {
    return this.fetchOptions(
      "operador",
      OptionsService.getOperadorOptions,
      query
    );
  };

  appendParam = (params, key, value) => {
    if (value === null || value === undefined || value === "") {
      return;
    }
    params.push(key + "=" + encodeURIComponent(value));
  };

  buildQueryString = () => {
    const { filters } = this.state;
    const params = [];
    const append = this.appendParam;

    // Parcela
    append(params, "status_parcela", filters.status_parcela);
    append(params, "status_conciliado", filters.status_conciliado);
    append(params, "forma_pagamento", filters.forma_pagamento);
    append(params, "data_vencimento__gte", filters.data_vencimento_ini);
    append(params, "data_vencimento__lte", filters.data_vencimento_fim);
    append(params, "data_pagamento__gte", filters.data_pagamento_ini);
    append(params, "data_pagamento__lte", filters.data_pagamento_fim);
    append(params, "valor_parcela__gte", filters.valor_parcela_min);
    append(params, "valor_parcela__lte", filters.valor_parcela_max);

    // Acordo
    append(params, "acordo__status_acordo", filters.acordo_status_acordo);
    append(params, "acordo__tipo_acordo", filters.acordo_tipo_acordo);
    append(params, "acordo__tipo_cobranca", filters.acordo_tipo_cobranca);
    append(
      params,
      "acordo__operador__username",
      filters.acordo_operador_username
    );
    append(params, "acordo__data_acordo__gte", filters.acordo_data_acordo_ini);
    append(params, "acordo__data_acordo__lte", filters.acordo_data_acordo_fim);
    append(params, "acordo__numero_cliente", filters.acordo_numero_cliente);
    append(params, "acordo__numero_processo", filters.acordo_numero_processo);
    append(
      params,
      "acordo__dias_em_atraso__gte",
      filters.acordo_dias_em_atraso_min
    );
    append(
      params,
      "acordo__dias_em_atraso__lte",
      filters.acordo_dias_em_atraso_max
    );
    append(
      params,
      "acordo__valor_acordo__gte",
      filters.acordo_valor_acordo_min
    );
    append(
      params,
      "acordo__valor_acordo__lte",
      filters.acordo_valor_acordo_max
    );

    // Pasta/Cliente
    append(params, "acordo__pasta__pasta", filters.acordo_pasta_pasta);
    append(params, "acordo__pasta__cpf_cnpj", filters.acordo_pasta_cpf_cnpj);
    append(params, "acordo__pasta__cooperado", filters.acordo_pasta_cooperado);
    append(
      params,
      "acordo__pasta__cooperado__icontains",
      filters.acordo_pasta_cooperado_search
    );
    append(params, "acordo__pasta__agencia", filters.acordo_pasta_agencia);
    append(params, "acordo__pasta__singular", filters.acordo_pasta_singular);

    return params.length > 0 ? "?" + params.join("&") : "";
  };

  clearFilters = () => {
    this.setState({
      filters: {
        // Parcela
        status_parcela: null,
        status_conciliado: null,
        forma_pagamento: null,
        data_vencimento_ini: null,
        data_vencimento_fim: null,
        data_pagamento_ini: null,
        data_pagamento_fim: null,
        valor_parcela_min: null,
        valor_parcela_max: null,
        // Acordo
        acordo_status_acordo: null,
        acordo_tipo_acordo: null,
        acordo_tipo_cobranca: null,
        acordo_operador_username: null,
        acordo_data_acordo_ini: null,
        acordo_data_acordo_fim: null,
        acordo_numero_cliente: null,
        acordo_numero_processo: null,
        acordo_dias_em_atraso_min: null,
        acordo_dias_em_atraso_max: null,
        acordo_valor_acordo_min: null,
        acordo_valor_acordo_max: null,
        // Pasta/Cliente
        acordo_pasta_pasta: null,
        acordo_pasta_cpf_cnpj: null,
        acordo_pasta_cooperado: null,
        acordo_pasta_cooperado_search: null,
        acordo_pasta_agencia: null,
        acordo_pasta_singular: null,
      },
    });
  };

  getActiveFiltersCount = () => {
    const { filters } = this.state;
    return Object.keys(filters).filter(function (key) {
      const value = filters[key];
      return value !== null && value !== undefined && value !== "";
    }).length;
  };

  handleGenerateReport = async (reportType) => {
    this.setState({
      loading: true,
      activeReport: reportType,
    });

    try {
      const queryString = this.buildQueryString();
      const endpoint =
        reportType === "concatenado"
          ? "acordo/report_parcela_concatenado/"
          : "acordo/report_parcela_por_linha/";

      const res = await api.get(endpoint + queryString);

      if (res && res.data && res.data.link) {
        window.open(res.data.link, "_blank");
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Erro ao gerar relatório:", error);
    } finally {
      this.setState({
        loading: false,
        activeReport: null,
      });
    }
  };

  formatCurrency = (value) => {
    if (value === undefined || value === null || value === "") {
      return "";
    }
    const str = String(value);
    return "R$ " + str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  parseCurrency = (value) => {
    if (typeof value !== "string") {
      return 0;
    }
    const numeric = value.replace(/\D/g, "");
    if (!numeric) {
      return 0;
    }
    return Number.parseFloat(numeric) / 100;
  };

  getStatusParcelaLabel = (value) => {
    const v = String(value);
    if (v === "0") {
      return "Não Paga";
    }
    if (v === "1") {
      return "Paga";
    }
    return v;
  };

  getStatusConciliadoLabel = (value) => {
    const v = String(value);
    if (v === "0") {
      return "Não Conciliado";
    }
    if (v === "1") {
      return "Conciliado";
    }
    return v;
  };

  renderParcelaFilters = () => {
    const {
      filters,
      statusParcelaOptions,
      statusConciliadoOptions,
      formaPagamentoOptions,
      loadingOptions,
    } = this.state;

    return (
      <div className="filter-section">
        <h3 className="filter-section-title">Filtros de Parcela</h3>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Status da Parcela</label>
              <Select
                showSearch
                placeholder="Selecione..."
                value={filters.status_parcela}
                onChange={(value) =>
                  this.onFilterChange("status_parcela", value)
                }
                onFocus={() => {
                  if (
                    !statusParcelaOptions ||
                    statusParcelaOptions.length === 0
                  ) {
                    this.fetchStatusParcelaOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.statusParcela ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {statusParcelaOptions.map(
                  function (option) {
                    return (
                      <Select.Option key={option} value={option}>
                        {this.getStatusParcelaLabel(option)}
                      </Select.Option>
                    );
                  }.bind(this)
                )}
              </Select>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Status Conciliado</label>
              <Select
                showSearch
                placeholder="Selecione..."
                value={filters.status_conciliado}
                onChange={(value) =>
                  this.onFilterChange("status_conciliado", value)
                }
                onFocus={() => {
                  if (
                    !statusConciliadoOptions ||
                    statusConciliadoOptions.length === 0
                  ) {
                    this.fetchStatusConciliadoOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.statusConciliado ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {statusConciliadoOptions.map(
                  function (option) {
                    return (
                      <Select.Option key={option} value={option}>
                        {this.getStatusConciliadoLabel(option)}
                      </Select.Option>
                    );
                  }.bind(this)
                )}
              </Select>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Forma de Pagamento</label>
              <Select
                showSearch
                placeholder="Selecione..."
                value={filters.forma_pagamento}
                onChange={(value) =>
                  this.onFilterChange("forma_pagamento", value)
                }
                onSearch={this.fetchFormaPagamentoOptions}
                onFocus={() => {
                  if (
                    !formaPagamentoOptions ||
                    formaPagamentoOptions.length === 0
                  ) {
                    this.fetchFormaPagamentoOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.formaPagamento ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {formaPagamentoOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Período de Vencimento</label>
              <DatePicker.RangePicker
                format="DD/MM/YYYY"
                placeholder={["Data Inicial", "Data Final"]}
                value={
                  filters.data_vencimento_ini && filters.data_vencimento_fim
                    ? [
                        moment(filters.data_vencimento_ini),
                        moment(filters.data_vencimento_fim),
                      ]
                    : undefined
                }
                onChange={(dates) =>
                  this.onDateRangeChange(
                    "data_vencimento_ini",
                    "data_vencimento_fim",
                    dates
                  )
                }
                style={{ width: "100%" }}
              />
            </div>
          </Col>

          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Período de Pagamento</label>
              <DatePicker.RangePicker
                format="DD/MM/YYYY"
                placeholder={["Data Inicial", "Data Final"]}
                value={
                  filters.data_pagamento_ini && filters.data_pagamento_fim
                    ? [
                        moment(filters.data_pagamento_ini),
                        moment(filters.data_pagamento_fim),
                      ]
                    : undefined
                }
                onChange={(dates) =>
                  this.onDateRangeChange(
                    "data_pagamento_ini",
                    "data_pagamento_fim",
                    dates
                  )
                }
                style={{ width: "100%" }}
              />
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12} md={12}>
            <div className="filter-group">
              <label className="filter-label">
                Valor da Parcela (De - Até)
              </label>
              <div className="range-input-group">
                <InputNumber
                  placeholder="Mín"
                  value={filters.valor_parcela_min}
                  onChange={(value) =>
                    this.onFilterChange("valor_parcela_min", value)
                  }
                  step={0.01}
                  precision={2}
                  formatter={this.formatCurrency}
                  parser={this.parseCurrency}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <div className="filter-group" style={{ marginTop: "25px" }}>
              <div className="range-input-group">
                <InputNumber
                  placeholder="Máx"
                  value={filters.valor_parcela_max}
                  onChange={(value) =>
                    this.onFilterChange("valor_parcela_max", value)
                  }
                  step={0.01}
                  precision={2}
                  formatter={this.formatCurrency}
                  parser={this.parseCurrency}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  renderAcordoFilters = () => {
    const {
      filters,
      tipoAcordoOptions,
      tipoCobrancaOptions,
      operadorOptions,
      loadingOptions,
    } = this.state;

    return (
      <div className="filter-section">
        <h3 className="filter-section-title">Filtros de Acordo</h3>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Status do Acordo</label>
              <Select
                placeholder="Selecione..."
                value={filters.acordo_status_acordo}
                onChange={(value) =>
                  this.onFilterChange("acordo_status_acordo", value)
                }
                allowClear
              >
                <Select.Option value="ATIVO">Ativo</Select.Option>
                <Select.Option value="CANCELADO">Cancelado</Select.Option>
                <Select.Option value="CONCLUIDO">Concluído</Select.Option>
              </Select>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Tipo de Acordo</label>
              <Select
                showSearch
                placeholder="Selecione..."
                value={filters.acordo_tipo_acordo}
                onChange={(value) =>
                  this.onFilterChange("acordo_tipo_acordo", value)
                }
                onSearch={this.fetchTipoAcordoOptions}
                onFocus={() => {
                  if (!tipoAcordoOptions || tipoAcordoOptions.length === 0) {
                    this.fetchTipoAcordoOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.tipoAcordo ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {tipoAcordoOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Tipo de Cobrança</label>
              <Select
                showSearch
                placeholder="Selecione..."
                value={filters.acordo_tipo_cobranca}
                onChange={(value) =>
                  this.onFilterChange("acordo_tipo_cobranca", value)
                }
                onSearch={this.fetchTipoCobrancaOptions}
                onFocus={() => {
                  if (
                    !tipoCobrancaOptions ||
                    tipoCobrancaOptions.length === 0
                  ) {
                    this.fetchTipoCobrancaOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.tipoCobranca ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {tipoCobrancaOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Operador</label>
              <Select
                showSearch
                placeholder="Digite o nome de usuário"
                value={filters.acordo_operador_username}
                onChange={(value) =>
                  this.onFilterChange("acordo_operador_username", value)
                }
                onSearch={this.fetchOperadorOptions}
                onFocus={() => {
                  if (!operadorOptions || operadorOptions.length === 0) {
                    this.fetchOperadorOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.operador ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {operadorOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Número do Cliente</label>
              <Input
                placeholder="Ex: 12345"
                value={filters.acordo_numero_cliente || ""}
                onChange={(e) =>
                  this.onFilterChange("acordo_numero_cliente", e.target.value)
                }
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Número do Processo</label>
              <Input
                placeholder="Ex: 0001234567890"
                value={filters.acordo_numero_processo || ""}
                onChange={(e) =>
                  this.onFilterChange("acordo_numero_processo", e.target.value)
                }
              />
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Período do Acordo</label>
              <DatePicker.RangePicker
                format="DD/MM/YYYY"
                placeholder={["Data Inicial", "Data Final"]}
                value={
                  filters.acordo_data_acordo_ini &&
                  filters.acordo_data_acordo_fim
                    ? [
                        moment(filters.acordo_data_acordo_ini),
                        moment(filters.acordo_data_acordo_fim),
                      ]
                    : undefined
                }
                onChange={(dates) =>
                  this.onDateRangeChange(
                    "acordo_data_acordo_ini",
                    "acordo_data_acordo_fim",
                    dates
                  )
                }
                style={{ width: "100%" }}
              />
            </div>
          </Col>
        </Row>
        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Dias em Atraso (De - Até)</label>
              <div className="range-input-group">
                <InputNumber
                  placeholder="Mín"
                  value={filters.acordo_dias_em_atraso_min}
                  onChange={(value) =>
                    this.onFilterChange("acordo_dias_em_atraso_min", value)
                  }
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <div className="filter-group" style={{ marginTop: "25px" }}>
              <div className="range-input-group">
                <InputNumber
                  placeholder="Máx"
                  value={filters.acordo_dias_em_atraso_max}
                  onChange={(value) =>
                    this.onFilterChange("acordo_dias_em_atraso_max", value)
                  }
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12} md={12}>
            <div className="filter-group">
              <label className="filter-label">Valor do Acordo (De - Até)</label>
              <div className="range-input-group">
                <InputNumber
                  placeholder="Mín"
                  value={filters.acordo_valor_acordo_min}
                  onChange={(value) =>
                    this.onFilterChange("acordo_valor_acordo_min", value)
                  }
                  step={0.01}
                  precision={2}
                  formatter={this.formatCurrency}
                  parser={this.parseCurrency}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <div className="filter-group" style={{ marginTop: "25px" }}>
              <div className="range-input-group">
                <InputNumber
                  placeholder="Máx"
                  value={filters.acordo_valor_acordo_max}
                  onChange={(value) =>
                    this.onFilterChange("acordo_valor_acordo_max", value)
                  }
                  step={0.01}
                  precision={2}
                  formatter={this.formatCurrency}
                  parser={this.parseCurrency}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  renderClienteFilters = () => {
    const {
      filters,
      agenciaOptions,
      cooperadoOptions,
      singularOptions,
      loadingOptions,
    } = this.state;

    return (
      <div className="filter-section">
        <h3 className="filter-section-title">Filtros de Pasta/Cliente</h3>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Pasta</label>
              <Input
                placeholder="Digite o nome da pasta"
                value={filters.acordo_pasta_pasta || ""}
                onChange={(e) =>
                  this.onFilterChange("acordo_pasta_pasta", e.target.value)
                }
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">CPF/CNPJ</label>
              <Input
                placeholder="Ex: 12345678900000"
                value={filters.acordo_pasta_cpf_cnpj || ""}
                onChange={(e) =>
                  this.onFilterChange("acordo_pasta_cpf_cnpj", e.target.value)
                }
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <div className="filter-group">
              <label className="filter-label">Agência</label>
              <Select
                showSearch
                placeholder="Ex: 0001"
                value={filters.acordo_pasta_agencia}
                onChange={(value) =>
                  this.onFilterChange("acordo_pasta_agencia", value)
                }
                onSearch={this.fetchAgenciaOptions}
                onFocus={() => {
                  if (!agenciaOptions || agenciaOptions.length === 0) {
                    this.fetchAgenciaOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.agencia ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {agenciaOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Cooperado</label>
              <Select
                showSearch
                placeholder="Digite o nome do cooperado"
                value={filters.acordo_pasta_cooperado}
                onChange={(value) =>
                  this.onFilterChange("acordo_pasta_cooperado", value)
                }
                onSearch={this.fetchCooperadoOptions}
                onFocus={() => {
                  if (!cooperadoOptions || cooperadoOptions.length === 0) {
                    this.fetchCooperadoOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.cooperado ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {cooperadoOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>

          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Cooperado (Busca Parcial)</label>
              <Input
                placeholder="Busca por parte do nome"
                value={filters.acordo_pasta_cooperado_search || ""}
                onChange={(e) =>
                  this.onFilterChange(
                    "acordo_pasta_cooperado_search",
                    e.target.value
                  )
                }
              />
            </div>
          </Col>
        </Row>

        <Row gutter={16} className="filter-row">
          <Col xs={24} sm={12}>
            <div className="filter-group">
              <label className="filter-label">Singular</label>
              <Select
                showSearch
                placeholder="Digite o valor singular"
                value={filters.acordo_pasta_singular}
                onChange={(value) =>
                  this.onFilterChange("acordo_pasta_singular", value)
                }
                onSearch={this.fetchSingularOptions}
                onFocus={() => {
                  if (!singularOptions || singularOptions.length === 0) {
                    this.fetchSingularOptions("");
                  }
                }}
                notFoundContent={
                  loadingOptions.singular ? <Spin size="small" /> : null
                }
                filterOption={false}
                allowClear
              >
                {singularOptions.map(function (option) {
                  return (
                    <Select.Option key={option} value={option}>
                      {option}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    const { loading, activeReport } = this.state;
    const activeFiltersCount = this.getActiveFiltersCount();

    if (loading) {
      return (
        <div className="report-loading-container">
          <Spin
            size="large"
            tip={
              "Gerando relatório " +
              (activeReport === "concatenado" ? "concatenado" : "por linha") +
              "..."
            }
          />
        </div>
      );
    }

    return (
      <div className="report-container">
        <Card className="report-card">
          <div className="report-header">
            <h1 className="report-title">Gerador de Relatórios de Parcelas</h1>
            <p className="report-description">
              Configure os filtros desejados para gerar relatórios precisos e
              detalhados
            </p>
          </div>

          <Divider />

          <div className="filters-info">
            {activeFiltersCount > 0 ? (
              <div className="active-filters-badge">
                <Icon type="filter" />
                <span>{activeFiltersCount} filtro(s) ativo(s)</span>
              </div>
            ) : null}
          </div>

          <Collapse accordion={false} className="filters-collapse">
            <Collapse.Panel
              header={
                <span className="collapse-header">
                  <Icon type="file-text" /> Filtros de Parcela
                </span>
              }
              key="1"
            >
              {this.renderParcelaFilters()}
            </Collapse.Panel>

            <Collapse.Panel
              header={
                <span className="collapse-header">
                  <Icon type="file-text" /> Filtros de Acordo
                </span>
              }
              key="2"
            >
              {this.renderAcordoFilters()}
            </Collapse.Panel>

            <Collapse.Panel
              header={
                <span className="collapse-header">
                  <Icon type="file-text" /> Filtros de Pasta/Cliente
                </span>
              }
              key="3"
            >
              {this.renderClienteFilters()}
            </Collapse.Panel>
          </Collapse>

          <Divider style={{ margin: "24px 0" }} />

          <div className="action-buttons">
            <Button
              type="default"
              onClick={this.clearFilters}
              style={{ marginRight: "8px" }}
              icon="delete"
            >
              Limpar Filtros
            </Button>

            <Button
              type="primary"
              onClick={() => this.handleGenerateReport("concatenado")}
              icon="file-excel"
              size="large"
              style={{ marginRight: "8px" }}
            >
              Relatório Concatenado
            </Button>

            <Button
              type="primary"
              onClick={() => this.handleGenerateReport("por_linha")}
              icon="file-excel"
              size="large"
            >
              Relatório por Linha
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}

export const ReportForm = Form.create({ name: "report_parcela" })(Report);



// WEBPACK FOOTER //
// ./src/pages/Relatorios/Parcela/component.jsx